import React, { FC } from 'react';
import Alert from '@mui/material/Alert';
import { AlertTitle } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

type AiAlertProps = {
    message?: string;
    title?: string;
};
const AiAlert: FC<AiAlertProps> = ({ title, message }: AiAlertProps) => {
    return (
        <Alert
            sx={{ backgroundColor: 'ai.light', color: 'ai.dark' }}
            icon={<AutoAwesomeIcon sx={{ color: 'ai.main' }} />}
        >
            {title ? <AlertTitle>{title}</AlertTitle> : undefined}
            {message ? <span style={{ whiteSpace: 'pre-line' }}>{message}</span> : undefined}
        </Alert>
    );
};

export default AiAlert;
